import BrowserStorage from './browser-storage';

export const session = new BrowserStorage(window.localStorage, 'appSession');



// WEBPACK FOOTER //
// ./src/services/session.js